



















import Vue from 'vue';

import ContactInfo from '@/types/ContactInfo';

export default Vue.extend({
    name: 'Contact',

    props: {
        value: Object as () => ContactInfo,
        isBoxed: {
            type: Boolean,
            default: true
        }
    }
});
